/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CreditCard = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path d="M4 17H10V15.5H4V17Z" fill={color} />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23 4H1V20H23V4ZM2.5 7.25V5.5H21.5V7.25H2.5ZM21.5 11.25H2.5V18.5H21.5V11.25Z"
                        fill={color}
                    />
                </svg>
        );
    };
